import { MagicConfigMixin } from '@gig/magic-common';
import { __extends, __decorate, __metadata } from 'tslib';
import { Prop, Component, Mixins } from 'vue-property-decorator';

/**
 * Component used as call to action element which comes in various decorative
 * variants.
 */
var ButtonComponent = /** @class */ (function (_super) {
    __extends(ButtonComponent, _super);
    function ButtonComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(ButtonComponent.prototype, "buttonVariant", {
        get: function () {
            if (!this.variant) {
                return '';
            }
            return "button--" + this.variant;
        },
        enumerable: false,
        configurable: true
    });
    __decorate([
        Prop({
            validator: function (type) {
                return ([
                    'primary',
                    'secondary',
                    'success',
                    'alert',
                    'error',
                    'light',
                    'transparent',
                    'secondary',
                ].indexOf(type) !== -1);
            },
            default: '',
        }),
        __metadata("design:type", String)
    ], ButtonComponent.prototype, "variant", void 0);
    __decorate([
        Prop({ type: String, default: 'button' }),
        __metadata("design:type", String)
    ], ButtonComponent.prototype, "buttonTag", void 0);
    __decorate([
        Prop(Boolean),
        __metadata("design:type", Boolean)
    ], ButtonComponent.prototype, "icon", void 0);
    __decorate([
        Prop(Boolean),
        __metadata("design:type", Boolean)
    ], ButtonComponent.prototype, "left", void 0);
    __decorate([
        Prop(Boolean),
        __metadata("design:type", Boolean)
    ], ButtonComponent.prototype, "right", void 0);
    __decorate([
        Prop(Boolean),
        __metadata("design:type", Boolean)
    ], ButtonComponent.prototype, "hollow", void 0);
    __decorate([
        Prop(Boolean),
        __metadata("design:type", Boolean)
    ], ButtonComponent.prototype, "round", void 0);
    __decorate([
        Prop(Boolean),
        __metadata("design:type", Boolean)
    ], ButtonComponent.prototype, "large", void 0);
    __decorate([
        Prop(Boolean),
        __metadata("design:type", Boolean)
    ], ButtonComponent.prototype, "small", void 0);
    __decorate([
        Prop(Boolean),
        __metadata("design:type", Boolean)
    ], ButtonComponent.prototype, "smallExtraPadding", void 0);
    __decorate([
        Prop(Boolean),
        __metadata("design:type", Boolean)
    ], ButtonComponent.prototype, "tiny", void 0);
    __decorate([
        Prop(Boolean),
        __metadata("design:type", Boolean)
    ], ButtonComponent.prototype, "wide", void 0);
    __decorate([
        Prop(Boolean),
        __metadata("design:type", Boolean)
    ], ButtonComponent.prototype, "noMargin", void 0);
    __decorate([
        Prop(Boolean),
        __metadata("design:type", Boolean)
    ], ButtonComponent.prototype, "lessMargin", void 0);
    __decorate([
        Prop(Boolean),
        __metadata("design:type", Boolean)
    ], ButtonComponent.prototype, "noPadding", void 0);
    __decorate([
        Prop(Boolean),
        __metadata("design:type", Boolean)
    ], ButtonComponent.prototype, "lessPadding", void 0);
    __decorate([
        Prop(Boolean),
        __metadata("design:type", Boolean)
    ], ButtonComponent.prototype, "addSpace", void 0);
    __decorate([
        Prop(Boolean),
        __metadata("design:type", Boolean)
    ], ButtonComponent.prototype, "loading", void 0);
    __decorate([
        Prop([Object, Number, String]),
        __metadata("design:type", Object)
    ], ButtonComponent.prototype, "to", void 0);
    ButtonComponent = __decorate([
        Component({
            name: 'ui-button',
        })
    ], ButtonComponent);
    return ButtonComponent;
}(Mixins(MagicConfigMixin)));

export default ButtonComponent;
